import {ReactNode} from 'react';
import {Navigate, useLocation} from '@tanstack/react-router';
import {LOGIN} from '@/anonymous/routing/paths';
import {DiagnosticReportFormModalContextProvider} from '@/practitioner/context/DiagnosticReportFormModalContext';
import ErrorBoundary from '@/shared/components/ErrorBoundary';
import LoggedInLayout from '@/shared/components/layout/LoggedInLayout';
import {SharedDataContextProvider} from '@/shared/components/layout/LoggedInLayout/contexts/SharedDataContext';
import {useIsLoggedIn} from '@/shared/contexts/UserContext/useUserContext';
import {useRedirectCookie} from '@/shared/hooks/useRedirectCookie';
import PractitionerSidebar from './PractitionerSidebar';
import useExtraUserMenuItems from './useExtraUserMenuItems';

export default function PractitionerLayout({children}: {children: ReactNode}) {
  const extraUserMenuItems = useExtraUserMenuItems();
  const isLoggedIn = useIsLoggedIn();
  const {pathname} = useLocation();
  useRedirectCookie(isLoggedIn, pathname);

  if (!isLoggedIn) {
    return <Navigate to={LOGIN} replace />;
  }

  return (
    <ErrorBoundary>
      <SharedDataContextProvider>
        <LoggedInLayout sidebar={PractitionerSidebar} extraUserMenuItems={extraUserMenuItems}>
          <DiagnosticReportFormModalContextProvider>
            {children}
          </DiagnosticReportFormModalContextProvider>
        </LoggedInLayout>
      </SharedDataContextProvider>
    </ErrorBoundary>
  );
}
